import { Button, Modal } from "antd";
import React from "react";

export default function PopUpEncuesta({ 
  visible, 
  //titulo = "Encuesta", 
  pregunta, 
  opciones = [],
  opcionCorrecta = 0,
  onSeleccionarOpcion,
  alCerrar,
  
}) {

  // const handleRespuestaSi = () => {
  //   if (onRespuestaSi) {
  //     onRespuestaSi();
  //   }
  //   alCerrar();
  // };

  // const handleRespuestaNo = () => {
  //   if (onRespuestaNo) {
  //     onRespuestaNo();
  //   }
  //   alCerrar();
  // };

  return (
    <Modal
      title={
        <h2 style={{ 
          textAlign: 'center', 
          marginBottom: 0,
          color: '#1890ff'
        }}>
          Pregunta
        </h2>
      }
      open={visible}
      onCancel={alCerrar}
      destroyOnClose={true}
      centered
      width={500}
      footer={[
        <Button 
          key="si" 
          type="primary" 
          size="large"
          onClick={()=>onSeleccionarOpcion(0)}
          style={{
            minWidth: '80px'
          }}
        >
          {/* {textoBtnSi} */}
          Sí
        </Button>,
        <Button 
          key="no" 
          size="large"
          onClick={()=>onSeleccionarOpcion(1)}
          style={{
            marginRight: '12px',
            minWidth: '80px'
          }}
        >
          {/* {textoBtnNo} */}
          No
        </Button>
        
      ]}
      styles={{
        content: {
          padding: '24px'
        }
      }}
    >
      <div style={{ 
        fontSize: 16,
        lineHeight: '1.6',
        textAlign: 'center',
        margin: '20px 0',
        color: '#333'
      }}>
        {pregunta}
      </div>
    </Modal>
  );
}